export default "__VITE_ASSET__DnB4C$Gx__"